// colour palette
export const colourPalette = {
  antdDefault: 'default', // default grey
  antdError: 'error', // error/rejected
  antdSuccess: 'success', // approve/success
  cplDisabled: '#8C8C8C', // grey-7
  cplError: '#CF1322', // red-7
  cplNormal: '#030852', // geekblue-10
  highlighted: '#FFC069', // search highlight
  searchActive: '#1890FF', // active search icon
};

// icon sizes
export const icon16px = '16px';
export const icon24px = '24px';
export const icon32px = '32px';

// access levels
export const accessLevels = {
  atactAdmin: 10, // 01 - 10
  siteAdmin: 20, // 11 - 20
  owner: 30, // 21 - 30
  resident: 40, // 31 - 40
  tenant: 50, // 41 - 50
};

// access types
export const accessAll = 'All';
export const accessEnt = 'Entry';
export const accessExt = 'Exit';

// badge offsets
export const badgeOffsetLeft = 0;
export const badgeOffsetTop = 10;

// date and time formats
export const dateFormat = 'YYYY-MM-DD';
export const timeFormat = 'HH:mm:ss';

// form items (24-column grid label + wrapper)
export const formItemLayout = {
  colSpanLabel: 8, // form label width
  colSpanNumber: 4, // for slider-input combo
  colSpanSlider: 12, // for slider-input combo
  colSpanWrapper: 16, // form input width
};

// timeouts (in ms)
export const filterTimeout = 1000;
export const formTimeout = 2000;

// notification timeouts (in seconds)
export const notificationTimeout = {
  timeoutError: 10,
  timeoutInfo: 5,
  timeoutSuccess: 3,
  timeoutWarning: 5,
};

// notification types (for antd message)
export const notificationType = {
  typeError: 'error',
  typeInfo: 'info',
  typeLoading: 'loading',
  typeSuccess: 'success',
  typeWarning: 'warning',
};

// table scroll height
export const scrollHeight = 'calc(100vh - 260px)';

// query limits
export const query100 = 100;
export const query200 = 200;

// sider width
export const siderWidth = 240;

// modal width
export const modalWidth = {
  extend: 768, // width for larger screens
  normal: 576, // default modal width
};

// request status
export const requestStatus = {
  approved: 1,
  pendings: 0,
  rejected: 2,
  approvedStr: 'Approved',
  pendingsStr: 'Pending',
  rejectedStr: 'Rejected',
};

// site configuration limits
export const siteConfigLimits = {
  householdTenantLimitMax: 10,
  householdTenantLimitMin: 1,
  kioskButtonCooldownMax: 120,
  kioskButtonCooldownMin: 10,
  kioskNotificationGracePeriodMax: 120,
  kioskNotificationGracePeriodMin: 10,
  visitorMaxDaysMax: 14,
  visitorMaxDaysMin: 1,
};

// user info limits
export const userInfoLimits = {
  contactNumberLength: 8, // contact number (without prefix)
  fullnameLengthMax: 128,
  fullnameLengthMin: 4,
  passwordLengthMax: 128,
  passwordLengthMin: 6,
  validateDebounce: 300, // delay (in ms) before validating
};

/** Maps directly to the FSM diagram and canonical backend contract */
export const ButtonState = Object.freeze({
  CONFLICT: 'CONFLICT',
  IN_USE: 'IN_USE',
  OFFLINE: 'OFFLINE',
  READY: 'READY',
});

/**
 * Base (hashed) URL for `siteService`. Use the axios `params` object to safely
 * append query parameters and keep the string readable:
 * ```javascript
 * // Safely creates: https://siteservice-e52lbycutq-as.a.run.app/doors?id=123
 * const response = await axios.get(`${SITE_SERVICE}/doors`, {
 *   headers: { Authorization: `Bearer ${idToken}` },
 *   params: { id: '123' },
 * });
 * ```
 */
export const SITE_SERVICE = 'https://siteservice-e52lbycutq-as.a.run.app';
// export const SITE_SERVICE =
//   'http://127.0.0.1:3020/atactconnect/asia-southeast1/siteService';

// version number
export const versionNumber = {
  appVersion: '0.4.2',
  dateString: '20261104',
};
